// extracted by mini-css-extract-plugin
export default {"openButton":"RemindersTable_openButton__D6ks5","emptyState":"RemindersTable_emptyState__Eih5A"};